import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getPromoCodeListing = createAsyncThunk(
  "promoCodeList/getPromoCodeListing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/cleaning/gift_coupon_discount`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const promoCodeListingSlice = createSlice({
  name: "promoCodeList",
  initialState: {
    loading: false,
    promoCodeListingData: null,
    error: null,
  },
  reducers: {
    ResetPromoCodeState: (state) => {
      state.loading = false;
      state.promoCodeListingData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPromoCodeListing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPromoCodeListing.fulfilled, (state, action) => {
        state.loading = false;
        state.promoCodeListingData = action.payload;
      })
      .addCase(getPromoCodeListing.rejected, (state, action) => {
        state.loading = false;
        state.promoCodeListingData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetPromoCodeState } = promoCodeListingSlice.actions;
export default promoCodeListingSlice.reducer;
